import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import TextArea from "../../../../../Component/Material-ui/TextArea";
import { ReducersTypes } from "../../../../../Constants";
import { isSpaceInString } from "Utils";


const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const AllowOnlyOneLeavePlan = [4, 8, 9, 10]; // ['unpaid', "birth", "spouse", "marriage"];
class NameDesc extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leavepolicyname: null,
      description: null,
      leavepolicy: null,
      notUnique: false,
      leaveType: [],
      list: [],
      actionidList: "1,2,3,4",
      completed: {},
      activeStep: 0,
      currentRoute: "list",
      AllStep: [],
      Breadcrums: ["Track", "Leaves", "Policy"],
      Policydetails: [],
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("leavespolicy,navigation");
  }

  componentWillReceiveProps(props) {
    if (
      JSON.stringify(props.leaveType) != JSON.stringify(this.state.leaveType)
    ) {
      if (props.leaveType.length > this.state.leaveType.length) {
        const newflag = !get(this.props, "InitLeavesPolicy.leavepolicyid", "");
        const lt = props.leaveType;
        // console.log('lt: ', lt);
        const index = lt && lt.findIndex((object) => object.leavetypeid == 4);
        const selectedleaves = localStorage.getItem("selectedleaves");
        // console.log('selectedleaves: ', selectedleaves);
        if (selectedleaves) {
          // console.log("here2");
          this.setState({ leaveType: JSON.parse(selectedleaves) });
          localStorage.setItem("selectedleaves", "");
        } else if (newflag) {
          // create
          // console.log("here3");
          lt[index].isinpolicy = true;
          const leavetypewithjson = !lt ? [] : lt.map((leave) => ({
            ...leave,
            leavetypejson: [],
          }));
          leavetypewithjson[index].leavetypejson = [
            {
              leavetypeid: 4,
              leavetypename: "Unpaid Leave",
              leavecategoryid: 1,
              leavepolicydetailid: null,
            },
          ];
          this.setState({ leaveType: leavetypewithjson });
        } else {
          // edit
          // console.log("here4");
          try {
            const selectedPolicyArray = get(this.props, "LEAVES_POLICY.Data", []).find(
              (policy) =>
                policy.leavepolicy
                == this.props.InitLeavesPolicy.leavepolicyid,
            );
            const resArr = props.leaveType.map((leave) => ({
              ...leave,
              isinpolicy:
                selectedPolicyArray
                && selectedPolicyArray.leavepolicyjson.filter(
                  (lpjson) => leave.leavetypeid == lpjson.leavetypeid,
                ).length != 0,
              leavetypejson:
                (selectedPolicyArray
                  && selectedPolicyArray.leavepolicyjson.filter(
                    (lpjson) => leave.leavetypeid == lpjson.leavetypeid,
                  ))
                || [],
            }));
            this.setState({ leaveType: resArr });
          } catch (err) {
            console.log("err: ", err);
          }
        }
      }
    }
    if (
      JSON.stringify(this.state.Policydetails)
      != JSON.stringify(props.InitLeavesPolicy.details)
    ) {
      this.setState(
        { Policydetails: props.InitLeavesPolicy.details },
        () => { },
      );
    }
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);

    this.props.onRef({
      onNext: this.validateNext,
    });
    const { InitLeavesPolicy } = this.props;
    this.setState(
      {
        leavepolicyname: InitLeavesPolicy.leavepolicyname,
        description: InitLeavesPolicy.description,
        leavepolicy: InitLeavesPolicy.leavepolicyid,
      },
      () => {
        const newflag = !get(this.props, "InitLeavesPolicy.leavepolicyid", "");
        if (newflag) {
          // this.handleChange("leavetypeid", 4, true);
        }
      },
    );
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    localStorage.setItem(
      "selectedleaves",
      JSON.stringify(this.state.leaveType),
    );
    // this.props.setCurrentLeaveTypes(this.state.leaveType);
    this.props.StepError(1, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  checkUnique(goNext) {
    const { InitLeavesPolicy, enqueueSnackbar } = this.props;
    if (this.state.leavepolicyname && this.state.leavepolicyname.trim() != "") {
      instance
        .post("leaves/uniqueLeavePolicyName", {
          name: this.state.leavepolicyname,
          id: InitLeavesPolicy.leavepolicyid,
        })
        .then(() => {
          this.setState({ notUnique: false }, () => {
            this.props.StepError(1, false);
            InitLeavesPolicy.leavepolicyname = this.state.leavepolicyname;
            this.props.CommonReducerAction(
              ReducersTypes.LEAVESPOLICY,
              InitLeavesPolicy,
            );
            if (goNext === true) {
              if (InitLeavesPolicy.details.length > 0) this.props.click();
              else {
                enqueueSnackbar("Please select at-least one leave plan", {
                  variant: "error",
                });
              }
            }
          });
        })
        .catch(() => {
          this.setState({ notUnique: true }, () => {
            this.props.StepError(1, true);
          });
        });
    } else {
      this.setState({ notUnique: true }, () => {
        this.props.StepError(1, true);
      });
    }
  }

  onNameChange(event) {
    this.setState({ leavepolicyname: event.target.value });
    this.props.ChangeSteppername(event.target.value, this.props.ParentIndex);
  }

  onDescChange(event) {
    this.setState({ description: event.target.value }, () => {
      const { InitLeavesPolicy } = this.props;
      InitLeavesPolicy.description = this.state.description;
      this.props.CommonReducerAction(
        ReducersTypes.LEAVESPOLICY,
        InitLeavesPolicy,
      );
    });
  }

  handleChange(name, typeid, check, typeindex) {
    // console.log('typeindex: ', typeindex);
    // console.log('check: ', check);
    // console.log('typeid: ', typeid);
    const { leaveType } = this.state;
    const { InitLeavesPolicy } = this.props;
    const ObjTypeIndex = leaveType.findIndex((x) => x.leavetypeid == typeid);
    let detailsNew = InitLeavesPolicy.details;
    const type = leaveType[ObjTypeIndex];
    switch (name) {
      case "leavetypeid": {
        if (check) {
          if (!this.StepperCount()) {
            return false;
          }
          detailsNew.push({
            tempIndex: detailsNew.length + 1,
            leavetypeid: type.leavetypeid,
            leavetypename: type.leavetypename,
            leavecategoryid: type.leavecategoryid,
            leavepolicydetailid: type.leavepolicydetailid || null,
          });
          leaveType[ObjTypeIndex].leavetypejson.push({
            leavetypeid: type.leavetypeid,
            leavetypename: type.leavetypename,
            leavecategoryid: type.leavecategoryid,
            leavepolicydetailid: type.leavepolicydetailid || null,
          });
          leaveType[ObjTypeIndex].isinpolicy = check;
        } else {
          detailsNew = detailsNew.filter(
            (detail) => detail.leavetypeid != typeid,
          );
          leaveType[ObjTypeIndex].leavetypejson = leaveType[
            ObjTypeIndex
          ].isinpolicy && leaveType[
            ObjTypeIndex
          ].leavetypejson.filter((x) => x.leaveid);
          // leaveType[ObjTypeIndex].leavetypejson = [];
          leaveType[ObjTypeIndex].isinpolicy = check;
          leaveType[ObjTypeIndex].leavetypecount = 1;
        }
        this.setState({ leaveType, Policydetails: detailsNew }, () => {
          this.UpdateReducer();
        });
        break;
      }
      case "leavetypename":
        {
          let detailsIndex1 = -1;
          let counter = 0;
          detailsNew.forEach((x, i) => {
            if (x.leavetypeid == type.leavetypeid) {
              if (counter == typeindex) {
                detailsIndex1 = i;
                counter += 1;
              }
              counter += 1;
            }
          });

          const typeData = {
            leaveid: type.leaveid,
            leavename: check.target.value,
            leavetypeid: type.leavetypeid,
            leavetypename: check.target.value,
            leavecategoryid: type.leavecategoryid,
            leavepolicydetailid: type.leavepolicydetailid || null,
          };
          if (detailsIndex1 != -1) {
            detailsNew[detailsIndex1] = typeData;
          }
          const leaveTypeIndex = get(type, "leavetypejson", []).filter((x) => x.leaveid).length + typeindex;
          leaveType[ObjTypeIndex].leavetypejson[leaveTypeIndex] = typeData;
          this.setState({ leaveType, Policydetails: detailsNew }, () => {
            this.UpdateReducer();
          });
        }
        break;
      case "leavetypecount": {
        if (typeid == type.leavetypeid) {
          if (check) {
            if (type.leavetypecount < 3) {
              detailsNew.push({
                tempIndex: detailsNew.length + 1,
                leavetypeid: type.leavetypeid,
                leavetypename: type.leavetypename,
                leavecategoryid: type.leavecategoryid,
                leavepolicydetailid: type.leavepolicydetailid || null,
              });
              leaveType[ObjTypeIndex].leavetypejson.push({
                leavetypeid: type.leavetypeid,
                leavetypename: type.leavetypename,
                leavecategoryid: type.leavecategoryid,
                leavepolicydetailid: type.leavepolicydetailid || null,
              });
              leaveType[ObjTypeIndex].leavetypecount += 1;
            }
          } else {
            if (detailsNew.length > 0) {
              detailsNew.pop();
            }
            if (leaveType[ObjTypeIndex].leavetypejson > 0) {
              leaveType[ObjTypeIndex].leavetypejson.pop();
              leaveType[ObjTypeIndex].leavetypecount += 1;
            }
          }
        }
        if (
          leaveType[ObjTypeIndex].leavetypecount
          < leaveType[ObjTypeIndex].leavetypejson.length
        ) {
          if (!this.StepperCount()) {
            return false;
          }
        }
        this.setState({ leaveType, Policydetails: detailsNew }, () => {
          this.UpdateReducer();
        });
        break;
      }
      case "removeleavetypecount":
        {
          let detailsIndex1 = -1;
          let counter = 0;
          detailsNew.forEach((x, i) => {
            if (x.leavetypeid == type.leavetypeid) {
              if (counter == typeindex) {
                detailsIndex1 = i;
                counter += 1;
              }
              counter += 1;
            }
          });
          detailsNew = detailsNew.filter((x, i) => i != detailsIndex1); // .splice(detailsIndex1, 1);
          const leaveTypeIndex = get(type, "leavetypejson", []).filter((x) => x.leaveid).length + typeindex;
          leaveType[ObjTypeIndex].leavetypejson = leaveType[
            ObjTypeIndex
          ].leavetypejson.filter((y, j) => j != leaveTypeIndex);
          leaveType[ObjTypeIndex].leavetypecount += 1;
          this.setState({ leaveType, Policydetails: detailsNew }, () => {
            this.UpdateReducer();
          });
        }
        break;
      default:
        break;
    }
  }

  StepperCount = () => {
    let count = 1;
    const MAXCOUNT = 10;
    for (const type of this.state.leaveType) {
      if (type.isinpolicy) {
        count += Number(type.leavetypecount);
        if (count > MAXCOUNT) {
          this.props.enqueueSnackbar(
            `Leave types can't be more than ${MAXCOUNT}`,
            {
              variant: "error",
            },
          );
          break;
        }
      }
    }
    return !(count > MAXCOUNT);
  };

  UpdateReducer = () => {
    this.props.CommonReducerAction(ReducersTypes.LEAVESPOLICY, {
      ...this.props.InitLeavesPolicy,
      details: [...this.state.Policydetails],
      // policy: [...this.state.Policydetails]
    });
    const data = {
      InitLeavesPolicy: {
        ...this.props.InitLeavesPolicy,
        details: [...this.state.Policydetails],
        // policy: [...this.state.Policydetails]
      },
    };
    this.props.ChangeStepper(data);
  };

  setHelperText = (key) => {
    this.props.setHelperText({
      helperText: this.props.Language.leavespolicy
        ? this.props.Language.leavespolicy[key]
        : "",
    });
  };

  validateNext = () => {
    if (this.state.leavepolicyname && !isSpaceInString(this.state.leavepolicyname)) {
      this.state.leavepolicyname = this.state.leavepolicyname.trim();
    }

    this.checkUnique(true);
  };

  addNewLeaveInThisType = (type) => {
    this.handleChange("leavetypecount", type.leavetypeid, true);
  };

  removeFromNewLeaveInThisType = (type) => {
    this.handleChange("leavetypecount", type.leavetypeid, false);
  };

  removeLeaveInThisType = (type, typeindex) => {
    this.handleChange(
      "removeleavetypecount",
      type.leavetypeid,
      false,
      typeindex,
    );
  };

  render() {
    const language = this.props.Language.attendancepolicy;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="padding-bottom-30 leave_policy_form width100">
          <p className="input-form-label" />
          <div className="device-wrapper leave_wrapper">
            <p className="form-input-label">
              <FormattedMessage
                id="LbPolicyName"
                defaultMessage="Policy Name"
              />
            </p>
            <div>
              {/* <input
                  type="text"
                  className="form-contryol"
                  autoComplete="off"
                  autoFocus
                  placeholder="Policy Name"
                  maxLength={50}
                  onChange={this.onNameChange.bind(this)}
                  value={this.state.leavepolicyname}
                  onBlur={this.checkUnique.bind(this, false)}
                  onFocus={() => this.setHelperText("HtPolicyName")}
                /> */}
              <TextField
                id="outlined-dense"
                margin="dense"
                variant="outlined"
                autoComplete="off"
                style={{ width: "100%" }}
                placeholder="Enter policy name"
                onChange={this.onNameChange.bind(this)}
                value={this.state.leavepolicyname}
                onBlur={this.checkUnique.bind(this, false)}
                onFocus={() => this.setHelperText("HtPolicyName")}
                maxLength="100"
                className="form-text-input"
                autoFocus
              />
              <br />
              {this.state.notUnique ? (
                <span className="caption-error leave-policy-error">
                  This doesn&apos;t look like a valid leave name
                </span>
              ) : null}
            </div>
          </div>
          <div className="device-wrapper leave_wrapper">
            <p className="form-input-label">
              <FormattedMessage
                id="LbDesciption"
                defaultMessage="Lets write a brief description about this policy"
              />
            </p>

            {/* <textarea
                className="input-area-section"
                placeholder="Description"
                maxLength="200"
                onChange={this.onDescChange.bind(this)}
                value={this.state.description}
                onFocus={() => this.setHelperText("HtDesciption")}
              /> */}
            <TextArea
              className="width100"
              maxLength="200"
              variant="outlined"
              placeholder="Description "
              multiline
              onChange={this.onDescChange.bind(this)}
              value={this.state.description}
              onFocus={() => this.setHelperText("HtDesciption")}
            />
          </div>
          <div className="inner-wrapper opaque margin-bottom-30">
            <p className="form-input-label">
              <span>
                Choose the type of leaves you would like to enable in this
                policy
              </span>
            </p>
            <div className="margin-top-20">
              {this.state.leaveType.map((type) => (
                <div
                  key="key"
                  className="leavetype-row"
                  style={{ borderBottom: "1px solid #ddd" }}
                >
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      md={3}
                      sm={1}
                      className="padding-top-20 padding-bottom-20"
                    // style={{ borderBottom: "1px solid #ddd" }}
                    >
                      <div style={{ marginTop: 8 }}>
                        <span>
                          <Checkbox
                            className="floatleft padding-top-0 padding-bottom-0 padding-right-0"
                            checked={type.leavetypeid == 4 ? true : get(type, "isinpolicy", "")}
                            disabled={type.leavetypeid == 4}
                            onClick={() => {
                              if (
                                AllowOnlyOneLeavePlan.includes(
                                  type.leavetypeid,
                                )
                                && type.leavetypejson.filter((x) => x.leaveid)
                                  .length > 0
                              ) {
                                return;
                              }
                              this.handleChange(
                                "leavetypeid",
                                type.leavetypeid,
                                get(type, "leavetypejson", "").length == 0,
                                // !type.isinpolicy
                              );
                            }}
                          />
                        </span>
                        <span className="floatleft margin-left-8 padding-top-2">
                          {type.leavetypename}
                        </span>
                      </div>
                    </Grid>

                    {type.isinpolicy && type.leavetypejson
                      && type.leavetypejson.map((leave, index) => (
                        <Grid
                          item
                          xs={12}
                          md={2}
                          sm={3}
                          className="choose-policy-type rename-policy"
                          key="key"
                        >
                          <TextField
                            className="floatleft width80"
                            id="aaa"
                            margin="dense"
                            variant="outlined"
                            disabled
                            // disabled={leave.leaveid}
                            onChange={(e) =>
                              this.handleChange(
                                "leavetypename",
                                type.leavetypeid,
                                e,
                                index
                                - type.leavetypejson.filter((x) => x.leaveid)
                                  .length,
                              )
                            }
                            value={leave.leavename || leave.leavetypename}
                            placeholder="Enter leave name"
                          />
                          {!leave.leaveid && type.leavetypeid != 4 && (
                            <span
                              onClick={() =>
                                this.removeLeaveInThisType(
                                  type,
                                  index
                                  - type.leavetypejson.filter((x) => x.leaveid)
                                    .length,
                                )
                              }
                              className=""
                            >
                              <i
                                className="material-icons muiicon cursour-pointer"
                                style={{ color: "#166ab3" }}
                              >
                                remove_circle
                              </i>
                            </span>
                          )}
                        </Grid>
                      ))}
                    <Grid
                      item
                      xs={12}
                      md={3}
                      sm={1}
                      className="padding-left-10 padding-right-10 padding-top-20 padding-bottom-20"
                    // style={{ borderBottom: "1px solid #ddd" }}
                    >
                      {type.isinpolicy
                        && get(type, "leavetypejson", []).length != 0
                        && get(type, "leavetypejson", []).length < 3
                        && !AllowOnlyOneLeavePlan.includes(type.leavetypeid) ? (
                          <span
                            onClick={() => this.addNewLeaveInThisType(type)}
                            className="margin-top-8 display-block"
                          >
                            <i
                              className="material-icons muiicon cursour-pointer"
                              style={{ color: "#166ab3" }}
                            >
                              add_circle
                          </i>
                          </span>
                        ) : null}
                    </Grid>
                  </Grid>
                </div>
              ))}
            </div>
          </div>
          {/* <Button variant="contained" color="primary" onClick={() => this.validateNext()}>
            Next
          </Button> */}
        </div>
      </IntlProvider>
    );
  }
}

NameDesc.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
  LEAVES_POLICY: state.LEAVES_POLICY,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(NameDesc)));

// eslint-disable-next-line no-lone-blocks
{
  /** old
   <div
                    className="depedent-select-list padding5"
                    style={{ position: "relative", height: 80 }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        margin: "auto",
                        height: "30%"
                      }}
                      onClick={() =>
                        type.leavetypeid != 4 &&
                        this.handleChange("leavetypeid", type.leavetypeid, !type.isinpolicy)
                      }
                    >
                      {type.leavetypename}
                    </span>
                    <div style={{ float: "right" }}>
                      <span className="number-wrapper">
                        <input
                          className="seatlimit"
                          type="number"
                          min="1"
                          max={AllowOnlyOneLeavePlan.includes(type.leavetypeid) ? 1 : 3}
                          step="1"
                          onChange={this.handleChange.bind(
                            this,
                            "leavetypecount",
                            type.leavetypeid
                          )}
                          value={type.leavetypecount}
                          disabled={!type.isinpolicy || type.leavetypeid == 4}
                          title={"Value must be greater than 1"}
                        />
                      </span>
                      {type.isinpolicy ? (
                        <span className="floatright margin-top-20 selected-box padding-right-10">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            onClick={() =>
                              type.leavetypeid != 4 &&
                              this.handleChange("leavetypeid", type.leavetypeid, false)
                            }
                          >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                        </span>
                      ) : (
                        <span
                          onClick={() =>
                            type.leavetypeid != 4 &&
                            this.handleChange("leavetypeid", type.leavetypeid, true)
                          }
                          className=" padding-right-10 not-selected-box margin-top-20"
                        />
                      )}
                    </div>
                  </div>


   */
  /** new
   <div>
    <Grid container>
      <Grid
        item
        xs={12}
        md={3}
        sm={1}
        className="padding-top-20 padding-bottom-20"
        style={{ borderBottom: "1px solid #ddd" }}
      >
        <div style={{ marginTop: 8 }}>
          <span>
            <Checkbox
              className="floatleft padding-top-0 padding-bottom-0 padding-right-0"
              checked={type.isinpolicy}
              disabled={type.leavetypeid == 4}
              onClick={() =>
                type.leavetypeid != 4 &&
                this.handleChange("leavetypeid", type.leavetypeid, !type.isinpolicy)
              }
            />
          </span>
          <span className="floatleft margin-left-8 padding-top-2">{type.leavetypename}</span>
        </div>
      </Grid>
      {selectedpolicy &&
        selectedpolicy.leavepolicyjson &&
        selectedpolicy.leavepolicyjson.map((leavetype, index) => {
          return (
            <Grid item xs={12} md={9} sm={3}>
              <Grid item xs={12} md={3} sm={3} className="choose-policy-type rename-policy">
                <TextField
                  id="aaa"
                  margin="dense"
                  variant="outlined"
                  disabled={
                    type.isinpolicy
                      ? leavetype.leavetypeid == type.leavetypeid && leavetype.leavetypeid != null
                        ? true
                        : false
                      : true
                  }
                  onChange={e => this.handleChange("leavetypename", type.leavetypeid, e, index)}
                  value={leavetype.leavetypeid == type.leavetypeid ? leavetype.leavename : ""}
                  // inputProps={{ maxLength: 90 }}
                  placeholder="Enter leave name"
                />
              </Grid>
              {type.leavetypeid != 4 && (
                <Grid
                  item
                  xs={12}
                  md={1}
                  sm={1}
                  className="padding-left-10 padding-right-10 padding-top-20 padding-bottom-20"
                  style={{ borderBottom: "1px solid #ddd" }}
                >
                  <span
                    onClick={this.handleChange("leavetypecount", type.leavetypeid)}
                    className="margin-top-8 display-block"
                  >
                    <i class="material-icons muiicon" style={{ color: "#166ab3" }}>
                      add_circle
                    </i>
                  </span>
                </Grid>
              )}
            </Grid>
          );
        })}
      {this.props.newPolicyCreate &&
        type.leavetypejson &&
        type.leavetypejson.map((leave, index) => {
          return (
            <Grid item xs={12} md={9} sm={3}>
              <Grid item xs={12} md={3} sm={3} className="choose-policy-type rename-policy">
                <TextField
                  id="aaa"
                  margin="dense"
                  variant="outlined"
                  onChange={e => this.handleChange("leavetypename", type.leavetypeid, e, index)}
                  value={leave.leavetypename}
                  // inputProps={{ maxLength: 90 }}
                  placeholder="Enter leave name"
                />
              </Grid>
              {type.leavetypeid != 4 && (
                <Grid
                  item
                  xs={12}
                  md={1}
                  sm={1}
                  className="padding-left-10 padding-right-10 padding-top-20 padding-bottom-20"
                  style={{ borderBottom: "1px solid #ddd" }}
                >
                  <span
                    onClick={this.handleChange("leavetypecount", type.leavetypeid)}
                    className="margin-top-8 display-block"
                  >
                    <i class="material-icons muiicon" style={{ color: "#166ab3" }}>
                      {" "}
                      add_circle
                    </i>
                  </span>
                </Grid>
              )}
            </Grid>
          );
        })}
    </Grid>
  </div>
  */
}
